import { createAsyncThunk } from '@reduxjs/toolkit';
import { TAdditionalFormResponse, TAdditionalFormParams } from 'shared/types/form';
import { IThunkApi } from 'shared/types/redux';
import { ResponseError } from 'shared/errors';
import { addNotification, setModalStatus, setStep } from 'shared/slices';
import { fetchAdditionalForm } from 'shared/services/fetchAdditionalForm';
import { EModalStatus } from 'shared/types/modal';

export const sendAdditionalForm = createAsyncThunk<TAdditionalFormResponse, TAdditionalFormParams, IThunkApi>(
  'form/sendAdditionalForm',
  async (params, thunkApi) => {
    const { rejectWithValue, extra, dispatch } = thunkApi;

    try {
      const { response, statusCode } = await fetchAdditionalForm(extra, params);

      if (statusCode === 200) {
        dispatch(setStep(2));

        dispatch(setModalStatus({ status: EModalStatus.Success }));

        return response;
      }

      throw new ResponseError({
        domain: 'sendForm',
        message: response.message,
      });
    } catch (e) {
      extra.logger.error(e);

      dispatch(addNotification({ text: 'Что-то пошло не так — попробуйте ещё раз', type: 'error' }));

      return rejectWithValue(e.message);
    }
  },
);
